import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function GetAtendimentoAssistenciaTecnicaService(idCaso: number) {
    return Service(
        Axios.get<IAtendimentoExtraDetalhado>(
            `/assistenciatecnica/atendimentos/getatendimento?idCaso=${idCaso}`
        )
    );
}
